// extracted by mini-css-extract-plugin
module.exports = {"addLevel":"CardForm_addLevel___gSv3","submitFormButton":"CardForm_submitFormButton__3R9vp"};